import React, { Component } from 'react'
import { Modal, Button, Tabs } from 'antd'
import PersonInfoBox from './PersonInfoBox'
import News from '../News'
import TwitterStatistics from '../TwitterStatistics';
import { Tweets } from '../Tweets'
// import PersonWikipedia from './PersonWikipedia'
import KnowledgeGraph from '../KnowledgeGraph';
import PersonEvents from './PersonEvents'
import axios from 'axios';
import { osintRequestAddress } from '../config'

const { TabPane } = Tabs;

export default class PersonDetails extends Component {
    state = {
        person: {},
        personinfobox: [],
        wiki: {},
        engNewsList: [],
        chnNewsList: [],
        personTweets: [],
        wordfreq: [],
        trends: {},
        personPublicTweets: [],
        kgData: [],
        infoboxhtml: "",
        validTabs: [],
    }

    componentDidMount() {
        const { person } = this.props
        this.sendPersonShow(person)
    }

    sendPersonShow = (person) => {
        this.setState({
            person: person
        })
        if (person.qcode) {
            axios.get(`${osintRequestAddress}/kg?qcode=` + person.qcode).then(
                response => {
                    if (response.data) {
                        this.setState({
                            personinfobox: response.data.infobox,
                            kgData: response.data.relatedNodes,
                            wiki: response.data.wikipedia.length > 0 ? response.data.wikipedia[0] : {},
                        })
                        if (response.data.relatedNodes && this.validateArr(response.data.relatedNodes) && !this.state.validTabs.includes("关系图谱")) {
                            this.setState({ validTabs: [...this.state.validTabs, "关系图谱"] })
                        }
                        if (response.data.wikipedia.length > 0) {
                            const { language, title } = response.data.wikipedia[0]
                            axios.get(`${osintRequestAddress}/wiki/infoboxhtml?lang=${language}&article=${title}`).then(
                                response => {
                                    if (response.data) {
                                        this.setState({
                                            infoboxhtml: response.data
                                        })
                                    }
                                },
                                error => { console.log("error", error) }
                            )
                        }
                    }
                },
                error => { console.log("error", error) }
            )
            this.setState({ validTabs: [...this.state.validTabs, "战略事件"] })
        }
        // 获取新闻
        // 获取英文新闻，优先从google news topic获取
        if (person.gnTopic) {
            axios.get(`${osintRequestAddress}/gnewstopic?url=` + person.gnTopic).then(
                response => {
                    if (response.data) {
                        this.setState({
                            engNewsList: response.data
                        })
                        if (response.data && this.validateArr(response.data) && !this.state.validTabs.includes("新闻报道")) {
                            this.setState({ validTabs: [...this.state.validTabs, "新闻报道"] })
                        }
                    }
                },
                error => { console.log("error", error) }
            )
        } else {
            if (person.en_name){
                axios.get(`${osintRequestAddress}/search?engine=googlenews&byapp=true&keyword=` + person.en_name).then(
                    response => {
                        if (response.data) {
                            this.setState({
                                engNewsList: response.data.results
                            })
                            if (response.data && response.data.results && this.validateArr(response.data.results) && !this.state.validTabs.includes("新闻报道")) {
                                this.setState({ validTabs: [...this.state.validTabs, "新闻报道"] })
                            }
                        }
                    },
                    error => { console.log("error", error) }
                )
            }            
        }
        // 获取中文新闻，优先从google news topic获取
        if (person.gnTopicChn) {
            axios.get(`${osintRequestAddress}/gnewstopic?url=` + person.gnTopicChn).then(
                response => {
                    if (response.data) {
                        this.setState({
                            chnNewsList: response.data
                        })
                        if (response.data && this.validateArr(response.data) && !this.state.validTabs.includes("新闻报道")) {
                            this.setState({ validTabs: [...this.state.validTabs, "新闻报道"] })
                        }
                    }
                },
                error => { console.log("error", error) }
            )
        }else{
            if (person.cn_name){
                axios.get(`${osintRequestAddress}/search?engine=googlenews&byapp=true&keyword=` + person.cn_name).then(
                    response => {
                        if (response.data) {
                            this.setState({
                                chnNewsList: response.data.results
                            })
                            if (response.data && response.data.results && this.validateArr(response.data.results) && !this.state.validTabs.includes("新闻报道")) {
                                this.setState({ validTabs: [...this.state.validTabs, "新闻报道"] })
                            }
                        }
                    },
                    error => { console.log("error", error) }
                )
            } 
        }


        // 获取最新推文                             
        if (person.screenName) {
            axios.get(`${osintRequestAddress}/tw?screenName=${person.screenName}&dotrans=true`).then(   //带翻译
                response => {
                    if (response.data && response.data.length > 0) {
                        this.setState({
                            personTweets: response.data
                        })
                        if (response.data && this.validateArr(response.data) && !this.state.validTabs.includes("个人言论")) {
                            this.setState({ validTabs: [...this.state.validTabs, "个人言论"] })
                        }
                    }
                },
                error => { console.log("error", error) }
            )
            // 获取推文词频和发帖频率                             
            axios.get(`${osintRequestAddress}/tw?screenName=${person.screenName}&wordfreqrange=50`).then(
                response => {
                    if (response.data) {
                        this.setState({
                            wordfreq: response.data.wordFrequency,
                            trends: response.data.trends
                        })
                    }
                },
                error => { console.log("error", error) }
            )
        }
        axios.get(`${osintRequestAddress}/tweets?keyword=%23` + person.en_name.replace(".", "").replace(" ", "")).then(
            response => {
                var tweetsSet = new Set();
                if (response.data) {
                    response.data.map((tweet) =>
                        tweetsSet.add(tweet)
                    )
                }
                axios.get(`${osintRequestAddress}/tweets?keyword=` + person.en_name).then(
                    response => {
                        if (response.data) {
                            response.data.map((tweet) =>
                                tweetsSet.add(tweet)
                            )
                        }
                        this.setState({
                            personPublicTweets: Array.from(tweetsSet)
                        })
                        if (this.state.personPublicTweets && this.validateArr(this.state.personPublicTweets) && !this.state.validTabs.includes("社媒动态")) {
                            this.setState({ validTabs: [...this.state.validTabs, "社媒动态"] })
                        }
                    },
                    error => { console.log("error", error) }
                )
            },
            error => { console.log("error", error) }
        )
    }
    validateArr = (arr) => {
        return Array.isArray(arr) && arr.length > 0
    }

    render() {
        return (
            <Modal className="person-detail" key={this.state.person ? this.state.person.id : null} title="人物画像" maskClosable={false} width={'70vw'} visible={this.props.isModalOpen} onCancel={this.props.handleModalShow}
                footer={[<Button key="close" type="primary" onClick={this.props.handleModalShow}>关闭</Button>]}>
                <Tabs key={this.props.person} defaultActiveKey={999}>
                    <TabPane tab={"基础资料"} key={999} style={{ align: 'center' }}>
                        <PersonInfoBox person={this.state.person} wikiIntro={this.state.wiki.content} infoboxhtml={this.state.infoboxhtml} />
                    </TabPane>
                    {this.state.validTabs.map((tab, index) => {
                        switch (tab) {
                            case "新闻报道":
                                return (
                                    <TabPane tab={tab} key={tab} style={{ align: 'center' }}>
                                        <News engNewsList={this.state.engNewsList} chnNewsList={this.state.chnNewsList}/>
                                    </TabPane>
                                )
                            case "个人言论":
                                return (
                                    <TabPane tab={tab} key={tab} style={{ align: 'center' }}>
                                        <TwitterStatistics screenName={this.state.person.screenName} tweets={this.state.personTweets} wordData={this.state.wordfreq} trends={this.state.trends} />
                                    </TabPane>
                                )
                            case "社媒动态":
                                return (
                                    <TabPane tab={tab} key={tab} style={{ align: 'center' }}>
                                        <Tweets tweets={this.state.personPublicTweets} />
                                    </TabPane>
                                )
                            case "关系图谱":
                                return (
                                    <TabPane tab={tab} key={tab} style={{ align: 'center' }}>
                                        <KnowledgeGraph kgData={this.state.kgData} wikiWord={this.state.wiki} />
                                    </TabPane>
                                )
                            case "战略事件":
                                return (
                                    <TabPane tab={tab} key={tab} style={{ align: 'center' }}>
                                        <PersonEvents id={this.props.person.id}/>
                                        {/* 战略事件 */}
                                        {/* <KnowledgeGraph kgData={this.state.kgData} wikiWord={this.state.wiki} /> */}
                                    </TabPane>
                                )
                            default:
                                return ''
                        }
                    })}
                </Tabs>
            </Modal>
        )
    }
}